(function() {
  if ($) {
    $(document).ready(function() {
      // 手机端的轮播图左右滑动
      $(".carousel").on("touchstart", function(event) {
        let xClick = event.originalEvent.touches[0].pageX;
        $(this).one("touchmove", function (event) {
          let xMove = event.originalEvent.touches[0].pageX;
          if (Math.floor(xClick - xMove) > 5) {
            $(this).carousel('next');
          }
          else if (Math.floor(xClick - xMove) < -5) {
            $(this).carousel('prev');
          }
        });
        $(".carousel").on("touchend", function () {
          $(this).off("touchmove");
        });
      })
    })
  }
})();


// WEBPACK FOOTER //
// ./app/javascript/lib/jquery/bootstrap-carousel-mobile.js